import { router } from 'expo-router';

import { Button, IconChevronLeft, Text, tokens } from '@fhs/ui';

interface IAuthHeaderMiddleProps {
  title: string;
}

export function AuthHeaderMiddle(props: IAuthHeaderMiddleProps) {
  return <Text.Heading type="four">{props.title}</Text.Heading>;
}

export function AuthHeaderLeft() {
  return (
    <Button
      type="ghost"
      onPress={() => {
        router.back();
      }}
    >
      <Button.Icon color={tokens.colors.$blackOpacity75} size={24}>
        <IconChevronLeft />
      </Button.Icon>
    </Button>
  );
}
